import {Item} from '../../../../../../redux/entities/inventory/item';
import {number, object, string} from 'yup';

export const ItemModalSchema = object<Item>({
  id: string().nullable(),
  name: string().required('Name is a required field'),
  estimatedCost: number().min(0, 'Cost must be at least 0').nullable()
});
